export default "__VITE_ASSET__ec46e162__"